import config from "config/config";
import type { HowItWorksCardProps } from "../HowItWorks.types";

export const cardsDetailed5StepsConfig: HowItWorksCardProps[] = [
  {
    number: 1,
    icon: `${config.staticUrl}/i/homepage/hiw-takes-2-mins.svg`,
    title: "Takes 2 minutes",
    description: "Making a claim for compensation is quick and easy.",
  },
  {
    number: 2,
    icon: `${config.staticUrl}/i/homepage/hiw-documents.svg`,
    title: "Adding docs is simple and secure",
    description:
      "You provide the relevant flight details and send us the supporting docs, including the boarding pass.",
  },
  {
    number: 3,
    icon: `${config.staticUrl}/i/homepage/hiw-legal.svg`,
    title: "We handle everything",
    description:
      "Our legal experts build a strong case on your behalf, negotiate with the airline, and take it to court if needed.",
  },
  {
    number: 4,
    icon: `${config.staticUrl}/i/homepage/hiw-bulb.svg`,
    title: "We keep you updated",
    description: "We send regular updates so you know what’s going on throughout the entire bureaucratic process.",
  },
  {
    number: 5,
    icon: `${config.staticUrl}/i/homepage/hiw-compensation.svg`,
    title: "You receive compensation",
    description: "We only get paid when you do, so you’ve got nothing to lose and plenty to gain.",
  },
];
